import { Capacitor, registerPlugin } from '@capacitor/core'

/**
 * QUITAR EL AHORRO DE BATERÍA · envoltura del plugin nativo.
 *
 * El lado Java vive en android/.../AhorroBateriaPlugin.java. Aquí solo se le
 * habla. Todo esto únicamente aplica en la app nativa de Android; en la web las
 * funciones responden "ya está bien" y no tocan nada, para que la interfaz no
 * tenga que preguntar dónde corre.
 *
 * Por qué importa: Android suspende las apps que no tienes abiertas para ahorrar
 * batería, y eso mata el servicio de ubicación y el push del técnico. La cura es
 * que el teléfono deje esta app fuera de esa optimización.
 */

type PluginBateria = {
  estaExento(): Promise<{ exento: boolean }>
  pedirExencion(): Promise<void>
}

const Bateria = registerPlugin<PluginBateria>('AhorroBateria')

function esAndroidNativo(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android'
}

/** ¿La app ya está fuera del ahorro de batería? En la web siempre "sí". */
export async function bateriaExenta(): Promise<boolean> {
  if (!esAndroidNativo()) return true
  try {
    const { exento } = await Bateria.estaExento()
    return exento
  } catch {
    // Si el plugin no está (APK vieja sin reconstruir), no molestar con el aviso.
    return true
  }
}

/** Abre el diálogo del sistema para dejar la app fuera del ahorro de batería. */
export async function pedirExencionBateria(): Promise<void> {
  if (!esAndroidNativo()) return
  await Bateria.pedirExencion()
}
